export default __webpack_public_path__ + "static/media/secured-app.87509ca0.png";